// https://stackoverflow.com/questions/2218999/how-to-remove-all-duplicates-from-an-array-of-objects
export const uniqueFileBy = (key: keyof File, fileList: File[]): File[] => {
  const cleanedFileList = fileList?.filter((file) => file)
  const ids = cleanedFileList?.map((file) => file[key])
  return cleanedFileList?.filter((file, index) => !ids.includes(file[key], index + 1)) || []
}
